export function listing(state = [], action) {
  // console.log(action.data, action.id);
  const { data, selection, id } = action;
  let isExist;

  if (selection === "bulk") {
    isExist = data?.filter((el) => el?.product_id === id)?.length % 2 === 0;
  }
  switch (action.type) {
    case "LISTING":
      if (selection === "bulk") {
        if (!isExist) {
          return state.concat(data.find((el) => el?.product_id === id));
        } else {
          data.filter((el) => !data.includes(el.id));
          return state?.filter((el) => el?.product_id !== id);
        }
      }
      return [data];
    default:
      return state;
  }
}

export function range(state = [], action) {
  switch (action.type) {
    case "RANGE":
      return action.data;
    default:
      return state;
  }
}
